import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: 'https://api-enterprise.zwiz.app',
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const toaCrmApi = {
  getTermAndConditions: (request) => {
    const { config } = request
    return instance().post('/toacrm/api/cms/term-and-condition/all', config)
  },
  createTermConditions: (request) => {
    const { config } = request
    return instance().post('/toacrm/api/cms/term-and-condition', config)
  },
  updateTermConditions: (request) => {
    const { config } = request
    return instance().put('/toacrm/api/cms/term-and-condition', config)
  },
  deleteTermConditions: (request) => {
    const { data } = request
    return instance().delete(`/toacrm/api/cms/term-and-condition`, { params: data })
  },
  updateStatusTermConditions: (request) => {
    const { config } = request
    return instance().put('/toacrm/api/cms/term-and-condition/publish', config)
  },
  getAgreeTermsAndConditions: (request) => {
    const { config } = request
    return instance().get('/toacrm/api/cms/term-and-condition/accept/users', config)
  },
  exportTrackingOrders: (request) => {
    const { config } = request
    return instance().post('/toa-crm/form-order', config)
  },
  importUpdateOrders: (request) => {
    const { config } = request
    return instance().post('/toa-crm/import-form-order', config)
  },
  getMemberLogs: (request) => {
    const { config } = request
    return instance().get(`/common/member-logs/${config.pageId}/${config.memberId}`)
  },
  blockMember: (request) => {
    const { config } = request
    return instance().get(`/toa-crm/block-member/${config.pageId}/${config.memberId}`, {
      params: config.blockNote
    })
  },
  unblockMember: (request) => {
    const { config } = request
    return instance().get(`/toa-crm/unblock-member/${config.pageId}/${config.memberId}`)
  },
  deleteMember: (request) => {
    const { config } = request
    return instance().delete(`/toa-crm/delete-member/${config.pageId}/${config.memberId}`)
  },
  getCampaign: (request) => {
    const { config } = request
    return instance().get(`/toa-crm/campaign`, config)
  },
  importPoint: (request) => {
    const { data } = request
    return instance().post('/toa-crm/import-campaign-member', data)
  },
  getCampaignMember: (request, campaignId) => {
    const { config } = request
    return instance().get(`/toa-crm/campaign-member/${campaignId}`, config)
  },
  createCampaign: (request) => {
    const { data } = request
    return instance().post('/toa-crm/campaign', data)
  },
  deleteCampaignMember: (request) => {
    const { config } = request
    return instance().delete(`/toa-crm/campaign-member/${config.pageId}/${config.id}`)
  },
  updateCampaignMemberPoint: (request) => {
    const { config } = request
    return instance().patch(`/toa-crm/campaign-member/${config.pageId}/${config.id}`, config)
  },
  getTemplateCampaignMember: (request) => {
    const { config } = request
    return instance().get(`toa-crm/template-campaign-member`, config)
  },
  getRewardPointLog: (pageId, rewardPointId) => {
    return instance().get(`/toa-crm/reward-point-log/${pageId}/${rewardPointId}`)
  },
  getTransactionPoint: (request) => {
    const { config } = request
    return instance().get(`/toa-crm/transaction-point/${config.pageId}/${config.memberId}`, {
      params: config.params
    })
  },
  getPromotion: (request) => {
    const { config } = request
    return instance().get('toa-crm/promotion-with-detail', config)
  },
  getPromotionById: (request) => {
    const { id, pageId } = request
    return instance().get(`/toa-crm/promotion-with-detail/${pageId}/${id}`)
  },
  postPromotion: (request) => {
    const { data } = request
    return instance().post('/toa-crm/promotion-with-detail', data)
  },
  patchPromotion: (request) => {
    const { data } = request
    return instance().patch(`/toa-crm/promotion/${data.page_id}/${data.promotionId}`, data)
  },
  deletePromotion: (request) => {
    const { pageId, promotionId } = request
    return instance().delete(`/toa-crm/promotion/${pageId}/${promotionId}`)
  },
  postPromotionFullPurchaseDetail: (request) => {
    const { data, pageId, promotionId } = request
    return instance().post(`/toa-crm/promotion-full-purchase-detail/${pageId}/${promotionId}`, data)
  },
  patchPromotionFullPurchaseDetail: (request) => {
    const { data, pageId, id } = request
    return instance().patch(`/toa-crm/promotion-full-purchase-detail/${pageId}/${id}`, data)
  },
  deletePromotionFullPurchaseDetail: (request) => {
    const { pageId, id } = request
    return instance().delete(`/toa-crm/promotion-full-purchase-detail/${pageId}/${id}`)
  },
  postPromotionMatchDetail: (request) => {
    const { data, pageId, promotionId } = request
    return instance().post(`/toa-crm/promotion-match-datail/${pageId}/${promotionId}`, data)
  },
  patchPromotionMatchDetail: (request) => {
    const { data, pageId, id } = request
    return instance().patch(`/toa-crm/promotion-match-datail/${pageId}/${id}`, data)
  },
  deletePromotionMatchDetail: (request) => {
    const { pageId, id } = request
    return instance().delete(`/toa-crm/promotion-match-datail/${pageId}/${id}`)
  },
  postGetAllBranch: (request) => {
    const { data } = request
    return instance().post('toacrm/branchs-dashboard', data)
  },
  getProductNameList: (request) => {
    const { pageId } = request
    return instance().get(`/toa-crm/product-name-list/${pageId}`)
  },
  deleteApproveRecript: (request) => {
    const { config } = request
    return instance().delete(`/toa-crm/reward-point/${config.pageId}/${config.id}`)
  },
  postSuperadminUpdateRewardPoint: (request) => {
    const { data } = request
    return instance().post('/toa-crm/super-admin-update-reward-point', data)
  },
  getProductMarketingList: (request) => {
    const { pageId } = request
    return instance().get(`/toa-crm/product-mkt-list/${pageId}`)
  },
  getProductSubMarketingList: (request) => {
    const { pageId } = request
    return instance().get(`/toa-crm/product-sub-mkt-list/${pageId}`)
  },
  postCheckPromotion: (request) => {
    const { data, pageId } = request
    return instance().post(`/toa-crm/check-promotion/${pageId}`, data)
  },
  getExportOrderSummary: (request) => {
    const { data } = request
    return instance().get(`/toa-crm/cms/ordersummary/export`, { params: data })
  }
}
export default toaCrmApi



// WEBPACK FOOTER //
// ./src/api/toa-crm.js